var _defs, _path, _path2, _path3, _path4, _path5, _path6, _rect, _path7, _path8, _path9, _path0, _path1, _path10, _rect2, _path11, _path12, _path13, _path14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCanarioAirLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 217.289,
    height: 33,
    viewBox: "0 0 217.289 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#ffb718;}.c{fill:#030504;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M364.664,280.42a9.456,9.456,0,1,0,9.456,9.456A9.465,9.465,0,0,0,364.664,280.42Z",
    transform: "translate(-270.349 -270.238)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M201.947,280.42a9.456,9.456,0,1,0,9.457,9.456A9.466,9.466,0,0,0,201.947,280.42Z",
    transform: "translate(-166.611 -270.238)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M614.246,269.644H561.92v13.362a15.08,15.08,0,0,1-8.117,13.362h60.443Zm-26.438,13.7v11.084H584.47v-3.359a11.411,11.411,0,1,1,3.338-8.058c0,.112-.013.221-.017.333Zm7,11.084h-3.338V271.589h3.338Zm16.288-19.5h-1.669a8.025,8.025,0,0,0-8.017,8.017v11.48h-3.338v-11.48a11.367,11.367,0,0,1,11.354-11.354h1.669Z",
    transform: "translate(-396.957 -263.368)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M601.91,284.217a8.08,8.08,0,1,0,8.08,8.08A8.088,8.088,0,0,0,601.91,284.217Z",
    transform: "translate(-422.476 -272.659)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M596.041,275.009a11.417,11.417,0,1,0,8.08,19.475v3.359h3.338V286.76h-.017c0-.112.017-.221.017-.333A11.431,11.431,0,0,0,596.041,275.009Zm0,19.5a8.08,8.08,0,1,1,8.08-8.08A8.088,8.088,0,0,1,596.041,294.506Z",
    transform: "translate(-416.607 -266.789)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M675.93,286.364v11.48h3.338v-11.48a8.025,8.025,0,0,1,8.016-8.017h1.669v-3.338h-1.669A11.367,11.367,0,0,0,675.93,286.364Z",
    transform: "translate(-474.816 -266.789)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 3.338,
    height: 22.835,
    transform: "translate(194.511 8.22)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M195.079,269.644a13.362,13.362,0,1,0,9.457,22.792v3.932h3.9V283.4h-.02c0-.131.02-.259.02-.39A13.377,13.377,0,0,0,195.079,269.644Zm0,22.818a9.456,9.456,0,1,1,9.457-9.456A9.466,9.466,0,0,1,195.079,292.462Z",
    transform: "translate(-159.743 -263.368)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M357.8,269.644a13.362,13.362,0,1,0,9.456,22.793v3.932h3.906V283.4h-.02c0-.131.02-.259.02-.39A13.378,13.378,0,0,0,357.8,269.644Zm0,22.818a9.456,9.456,0,1,1,9.456-9.456A9.465,9.465,0,0,1,357.8,292.462Z",
    transform: "translate(-263.48 -263.368)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M277.514,269.644a13.377,13.377,0,0,0-13.362,13.362v13.362h3.9V283.006a9.456,9.456,0,0,1,18.913,0v13.362h3.9V283.006A13.377,13.377,0,0,0,277.514,269.644Z",
    transform: "translate(-212.297 -263.368)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M121.094,283.006a13.377,13.377,0,0,0,13.361,13.362h7.894v-3.906h-7.894a9.456,9.456,0,0,1,0-18.912h7.894v-3.906h-7.894A13.377,13.377,0,0,0,121.094,283.006Z",
    transform: "translate(-121.094 -263.368)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M426.865,282.932v13.436h3.906V282.932a9.392,9.392,0,0,1,9.382-9.382h1.953v-3.906h-1.953A13.3,13.3,0,0,0,426.865,282.932Z",
    transform: "translate(-316.031 -263.368)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M521.33,269.643H511.124a13.361,13.361,0,0,0-12.582,17.862q.216.6.488,1.178t.594,1.119q.161.272.335.535a13.467,13.467,0,0,0,1.146,1.5q.416.471.874.9t.955.817a13.429,13.429,0,0,0,2.127,1.354q.564.289,1.159.524a13.282,13.282,0,0,0,4.45.924v.012h.455a13.321,13.321,0,0,0,9.444-3.918,13.487,13.487,0,0,0,1.26-1.455,13.292,13.292,0,0,0,2.658-7.989V269.643Zm-.75,13.363a9.461,9.461,0,0,1-11.36,9.263,9.326,9.326,0,0,1-.905-.233,9.457,9.457,0,0,1,0-18.06q.444-.138.905-.233a9.468,9.468,0,0,1,1.9-.192h9.456Z",
    transform: "translate(-361.23 -263.368)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 3.906,
    height: 26.725,
    transform: "translate(129.47 6.275)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M480.23,252.331a1.954,1.954,0,0,0-1.953,1.953v.055a1.93,1.93,0,0,0,1.953,1.925,1.977,1.977,0,0,0,1.953-1.98A1.953,1.953,0,0,0,480.23,252.331Z",
    transform: "translate(-348.807 -252.331)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M526.109,293.156a2.25,2.25,0,0,0,2.225-2.254,2.225,2.225,0,1,0-4.451,0v.056A2.2,2.2,0,0,0,526.109,293.156Z",
    transform: "translate(-377.882 -275.503)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M552.857,256.462h.67v-3.273H554.7v-.548h-3.012v.548h1.164Z",
    transform: "translate(-395.612 -252.529)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M562.029,255.228l-.068-1.7,1.1,2.929h.481l1.1-2.931-.065,1.7v1.233h.671v-3.821h-.873l-1.073,2.908-1.076-2.908h-.873v3.821h.673Z",
    transform: "translate(-401.772 -252.529)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanarioAirLogo);
export default __webpack_public_path__ + "static/media/canarioAirLogo.fec6c9e4c07fa91267990ed42ea45ad2.svg";
export { ForwardRef as ReactComponent };